<template>
    
    <div class="page__content" >

        <HeaderBody/>

        <div class="promotions">
                    <div class="promotions__wrapper">

                        <div class="search" style="margin-top: 20px; margin-bottom: 0px;">
                            <div class="search__container" >
                                <div class="search__wrap">
                                    <div class="search__title h3" style="color:#ffffff">Omcdex Market Maker Program</div>
                                    <div class="search__info" style="margin-bottom: 5px;">The OMCDEX Market Maker Program is designed to optimize user capital using advanced trading algorithms that execute precise trades in all market conditions. It also offers exclusive benefits focused on capital efficiency, risk management, technology, and rewards.</div>
                                    
                                </div>

                                <button class="operations__btn btn btn_blue" style="margin-right: 20px; border-width: 2px; border-style: solid; border-color: #ffffff; margin-top: 10px;" @click="deposit">Deposit</button>

                                <button v-if="ommpXrp > 0" class="operations__btn btn btn_blue" style="margin-right: 20px; border-width: 2px; border-style: solid; border-color: #ffffff; margin-top: 10px;" @click="transfer">withdraw</button>

                                <button v-if="ommpXrp > 0" class="operations__btn btn btn_blue" style="margin-right: 20px; border-width: 2px; border-style: solid; border-color: #FF2525; background-color: #FF2525 ; margin-top: 10px;" @click="closeAccount">Close ommp</button>

                                
                                
                                <!--
                                    <div class="search__preview">
                                    <img src="@/assets/dashAssets/img/crown2.png" alt="">
                                </div>
                                -->
                            </div>
                        </div>
                        
                        <br>
                        <hr>
                        <br>
                        <br>
                        
                        <div class="promotions__list">

                            <div class="promotions__item" v-if="ommpXrp > 0">
                                <a class="promotions__preview" style="width: 100%; display:flex; justify-content:center; align-items:center; margin-top: 20px;">
                                    <img src="https://assets.coincap.io/assets/icons/xrp@2x.png" alt="" style="width: 50px; border-radius: 50%; ">

                                    <h5 style="color:#ffffff; margin-top: 5px; margin-left: 10px;">XRP</h5>
                                </a>
                                

                                <div style="width: 100%; display:flex; justify-content:space-around; align-items:center; flex-direction: column;">
                                    
                                    
                                </div>     

                                <div class="promotions__body">

                                    <div class="hr-line" style="opacity: 0.1;"></div>
                                    

                                    <div>

                                        
                                        <div style="width: 100%; display:flex; justify-content:space-between; align-items:center; padding: 10px; margin-top: 20px;">
                                            
                                            <div style="display: flex; justify-content: center; align-items: center;">
                                                
                                                <p style="font-size: 14px; color:#8f8e8e; ">Amount</p>
                                                <img src="@/assets/dashAssets/img/lock.png" alt="" style="width: 16px; margin-left: 5px; margin-top: -3px;">
                                            </div>

                                            <p>{{ ommpXrp }} XRP</p>
                                            
                                        </div>

                                        <div style="width: 100%; display:flex; justify-content:space-between; margin-top: 20px; align-items:center; padding: 10px">
                                            <p style="font-size: 14px; color:#8f8e8e; ">PNL</p>
                                            <p class="promotions__date bg-green-opacity color-green" >+{{ pnl }} XRP</p>
                                            
                                            
                                        </div>

                                        <div style="width: 100%; display:flex; justify-content:space-between; align-items:center; padding: 10px; margin-top: 60px; margin-bottom: 40px;">
                                            
                                            <div style="display: flex; justify-content: center; align-items: center;">
                                                
                                                <p style="font-size: 14px; color:#8f8e8e; ">SAFU</p>
                                                <img src="@/assets/dashAssets/img/lock.png" alt="" style="width: 16px; margin-left: 5px; margin-top: -3px;">
                                            </div>

                                            <p>20,000 XRP</p>
                                        </div>

                                        
                                    </div>

                                    
                                    

                                </div>
                            </div>
                            
                            
                        </div>
                        
                    </div>
        </div>

    </div>

        

        <div style=" display: flex; justify-content: center; align-items: center; z-index: 9999;  " class="loadingModalBg" ref="loadingModal">

            <div class="popup__container" style="width: 300px; background-color:#1F2128; border-radius: 30px; padding: 20px;">
                        
                <div class="popup__box">

                    <div class="popup__fieldset" >
                        
                        <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                            
                            <img src="@/assets/dashAssets/img/loading.gif" alt="">

                            <p style="text-align: center; color: #ffffff;">{{loadingText}}</p>
                            
                        </div>

                        
                        
                        
                    </div>
                    

                    

                    
                </div>
                
            </div>

        </div>

        <div style=" display: flex; justify-content: center; align-items: center; z-index: 9999;  " class="loadingModalBg" ref="successModal">

        <div class="popup__container" style="width: 300px; background-color:#1F2128; border-radius: 30px; padding: 20px;">
                    
            <div class="popup__box">

                <div class="popup__fieldset" >
                    
                    <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                        
                        <img src="@/assets/dashAssets/img/done.png" alt="" style="width: 100px; margin: 10px;">

                        <p style="text-align: center; margin-bottom: 40px; color: #ffffff;">{{successText}}</p>

                        <button class="operations__btn btn btn_blue" @click="closeS">Okay</button>
                        
                    </div>

                    
                    
                    
                    
                </div>
                

                

                
            </div>
            
        </div>

        </div>

        <div style=" display: flex; justify-content: center; align-items: center; z-index: 9999;  " class="loadingModalBg" ref="successModal2">

        <div class="popup__container" style="width: 300px; background-color:#1F2128; border-radius: 30px; padding: 20px;">
                    
            <div class="popup__box">

                <div class="popup__fieldset" >
                    
                    <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                        
                        <img src="@/assets/dashAssets/img/done.png" alt="" style="width: 100px; margin: 10px;">

                        <p style="text-align: center; margin-bottom: 40px; color: #ffffff;">{{successText2}}</p>

                        <button class="operations__btn btn btn_blue" @click="closeS2">Okay</button>
                        
                    </div>

                    
                    
                    
                    
                </div>
                

                

                
            </div>
            
        </div>

        </div>

        <div style=" display: flex; justify-content: center; align-items: center; z-index: 9999;  " class="loadingModalBg" ref="errorModal">

        <div class="popup__container" style="width: 300px; background-color:#1F2128; border-radius: 30px; padding: 20px;">
                    
            <div class="popup__box">

                <div class="popup__fieldset" >
                    
                    <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                        
                        <img src="@/assets/dashAssets/img/error.png" alt="" style="width: 100px; margin: 10px;">

                        <p style="text-align: center; margin-bottom: 40px; color: #ffffff;">{{errorText}}</p>

                        <button class="operations__btn btn btn_blue" @click="closeE">Okay</button>
                        
                    </div>

                    
                    
                    
                </div>
                

                

                
            </div>
            
        </div>

        </div>

        

        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg" ref="transferModal">

        <div class="popup__container" style="width: 400px; background-color:#1F2128; border-radius: 30px; padding: 20px;">
                    
            <div class="popup__box">

                <div class="popup__fieldset" >
                    
                    <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                        
                        <h5 style="color: #fff; text-align: center; margin-top: 20px; margin-bottom: 30px;">Withdraw profits</h5>

                        <div class="wallets__info" style="color: #8f8e8e; font-size: 12px; text-align: center; margin-top: -10px;">Withdraw profits to your spot wallet</div>
                        
                        <div class="hr-line" style="opacity: 0.1; margin-top: 20px;"></div>

                        <div class="field__wrap" style="margin-bottom: 50px; margin-top: 40px;">
                            <h3 style="text-align: center; width: 100%; " class="color-green">{{ pnl }} XRP</h3>
                        </div>

                        <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
                            <button class="operations__btn btn btn_blue" @click="withdraw" style="margin-right: 20px;">Confirm</button>
                            <button class="operations__btn btn btn_outline" style="border: #da4bfb; border-width: 1px; border-style: solid; color: #da4bfb;" @click="closeT">Close</button>
                        </div>

                        
                        
                    </div>

                    
                    
                    
                </div>
                

                

                
            </div>
            
        </div>

        </div>

        <div style=" display: flex; justify-content: center; align-items: center;   " class="loadingModalBg" ref="warningModal">

        <div class="popup__container" style="width: 300px; background-color:#1F2128; border-radius: 30px; padding: 20px;">
                    
            <div class="popup__box">

                <div class="popup__fieldset" >
                    
                    <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                        
                        <img src="@/assets/dashAssets/img/warning.png" alt="" style="width: 100px; margin: 10px;">

                        <p style="text-align: center; margin-bottom: 40px; color: #ffffff;">Are you sure you want to close your OMMP account? Your profits and locked XRP will be transferred to your spot wallet</p>

                        <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
                            <button class="operations__btn btn btn_blue" @click="closeAccount2" style="margin-right: 20px;">Yes</button>
                            <button class="operations__btn btn btn_outline" style="border: #da4bfb; border-width: 1px; border-style: solid; color: #da4bfb;" @click="closeW">Cancel</button>
                        </div>
                        
                    </div>

                    
                    
                    
                </div>
                

                

                
            </div>
            
        </div>

        </div>

        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg" ref="depositModal">

        <div class="popup__container" style="width: 400px; background-color:#1F2128; border-radius: 30px; padding: 20px;">
                    
            <div class="popup__box">

                <div class="popup__fieldset" >

                    <h5 style="color: #fff; text-align: center; margin-top: 20px; margin-bottom: 30px;">OMMP Deposit</h5>
                    
                    <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">

                        

                        <div class="operations__item">
                                        
                                        <div class="operations__text">
                                            <strong> </strong>
                                            Only send XRP to this address. Sending any other asset to this address may result in the loss of your deposit!
                                        </div>
                                        
                                        <hr>
                                        <br>

                                        <p @click="copy" style="width:100%; text-align: center; word-wrap: break-word; background-color: #2A2D36; border-radius: 10px; padding: 10px; font-size: 12px;" >{{xrpSpotAddress}}</p>

                                        <p class="operations__text" style="text-align:center; width: 100%; font-size: 10px; margin-top: 5px; ">click address to copy!</p>
                                        
                                        <hr>

                                        <br>

                                        <div class="operations__preview">
                                            <img src="" alt="">
                                            <img :src="qrCode" alt="">
                                        </div>
                                    </div>
                        
                        

                        <div style="display: flex; justify-content: center; align-items: center; margin-top: 20px;">

                            <button class="operations__btn btn btn_blue " style="background-color: #FF7A68; margin-left: 20px;" @click="closeD">Close</button>

                        </div>
                        
                    </div>

                    
                    
                    
                    
                </div>
                

                

                
            </div>
            
        </div>

        </div>

        

        
</template>

<style scoped>
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: grey;
    opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: grey;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
    color: grey;
    }

    

</style>

<script>

    import { doc, addDoc, collection, query, where, getDocs, getDoc, serverTimestamp, updateDoc, increment } from "firebase/firestore"; 
    import { db } from '@/firebase';
    import axios from 'axios';
    import HeaderBody from '@/components/dashboard/HeaderBody.vue';

    export default {

        components:{
            HeaderBody,
        },

        mounted(){

            this.niceSelect();

            document.getElementById("rWallet").classList.remove("active");
            document.getElementById("rSwap").classList.remove("active");
            document.getElementById("rStaking").classList.remove("active");
            document.getElementById("rTrans").classList.remove("active");
            document.getElementById("rCard").classList.remove("active");
            document.getElementById("rBorrow").classList.remove("active");

            document.getElementById("rOmmp").classList.add("active");

            if(sessionStorage.getItem("email").toLowerCase() != "kleffkevin@gmail.com" && sessionStorage.getItem("email").toLowerCase() != "mmerrett45@gmail.com" ){

                this.$router.push({name: 'wallet'})

            }

            this.getAddress();
            this.getXrp();
            
        },

        data(){
            return{
                loadingText:"",
                successText: "",
                successText2: "",
                errorText: "",
                stakingList: [],
                email: sessionStorage.getItem("email"),
                

                pnl: "",
                xrpAmount: "",
                ommpXrp: "",
                price: "",
                ommpDate: "",
                xrpSpotAddress: "",
                xrpSpotId: "",
                ommpAddressXrp: "",
                qrCode: "",
            }
        },

        methods:{

            round(num, decimals){
                return +(Math.round(num + "e" + decimals) + "e-" + decimals);
            },

            niceSelect(){
                $('.select').niceSelect();
            },

            copy(){
                navigator.clipboard.writeText(this.xrpSpotAddress);
                this.$refs.successModal2.classList.add("bg-active");
                this.successText2 = "The address has been copied to your clipboard";
            },

            niceSelect2(){
                var option = $('.js-tabs-select .option');

                option.on('click', function () {
                    var thisOption = $(this),
                        indexOption = thisOption.index();
                    console.log(indexOption);
                    $('.js-tabs-item').hide();
                    $('.js-tabs-item').eq(indexOption).fadeIn();
                });
            },

            magnific(){
                    var link = $('.js-popup-open');
                    link.magnificPopup({
                        type: 'inline',
                        fixedContentPos: true,
                        removalDelay: 200,
                        callbacks: {
                            beforeOpen: function beforeOpen() {
                                this.st.mainClass = this.st.el.attr('data-effect');
                            }
                        }
                    });
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            closeS2(){
                this.$refs.successModal2.classList.remove("bg-active");
                
            },

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeT(){
                this.$refs.transferModal.classList.remove("bg-active");
            },

            closeW(){
                this.$refs.warningModal.classList.remove("bg-active");
            },

            closeD(){
                this.$refs.depositModal.classList.remove("bg-active");
            },

            async getAddress(){
                const q = query(collection(db, "UserWallets"), where("userId", "==", sessionStorage.getItem("id")), where("symbol", "==", "XRP"));

                const querySnapshot = await getDocs(q);
                querySnapshot.forEach((doc) => {
                
                    this.xrpSpotAddress = doc.data().address;
                    this.xrpSpotId = doc.id;
                    this.qrCode = "https://quickchart.io/qr?text="+this.xrpSpotAddress;
                    
                });
            },

            async getXrp(){
                const docRef = doc(db, "Users", sessionStorage.getItem("id"));
                const docSnap = await getDoc(docRef);
                this.ommpXrp = docSnap.data().ommpXrp;
                this.ommpDate = docSnap.data().ommpDate.seconds

                this.getPNL();
            },

            async getPNL(){

                let lockedAmount = this.ommpXrp;
                let todaySecs = new Date().getTime()/1000;
                let startDateSecs = this.ommpDate;

                let checkSecs = todaySecs - startDateSecs;
                let days = checkSecs/(60 * 60 * 24);

                let rApy = 8/100;
                let mReward = lockedAmount * (rApy/30) * Number(days);
                
                this.pnl = this.round(mReward, 4)

                //get price
                const response =  await axios.get("https://api.omcdex.com/v1/coin-price", {
                    params: {
                        ids: 52
                    }
                })
                this.price = Number(Object.values(response.data.data)[0].price);

                if(lockedAmount == 0){
                    this.pnl = 0
                }
            },

            transfer(){
                this.$refs.transferModal.classList.add("bg-active");
            },

            async transfer2(){

                let balance, walletId, newBalance, newOmmpXrp, amountUsd;

                if( this.xrpAmount == 0 || this.xrpAmount == ""){
                    this.$refs.errorModal.classList.add("bg-active");
                    this.errorText = "Please enter a valid amount";
                    return
                }

                this.loadingText = "Transferring XRP..."
                this.$refs.loadingModal.classList.add("bg-active");

                //check balance
                const q = query(collection(db, "UserWallets"), where("userId", "==", sessionStorage.getItem("id")), where("symbol", "==", "XRP"));

                const querySnapshot = await getDocs(q);

                querySnapshot.forEach((doc) => {

                    balance = doc.data().balance;
                    walletId = doc.id;

                })

                if(Number(balance) < Number(this.xrpAmount) ){
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    this.errorText = "Insufficient XRP balance";
                    return;
                }

                //update balance
                newBalance = balance - this.xrpAmount;

                const wRef = doc(db, "UserWallets", String(walletId));
                await updateDoc(wRef, {
                    balance: this.round(Number(newBalance), 7)
                });

                //transfer xrp
                let temp = this.xrpAmount + this.ommpXrp;
                newOmmpXrp = this.round(temp, 7);

                const wRef2 = doc(db, "Users", sessionStorage.getItem("id"));
                await updateDoc(wRef2, {
                    ommpXrp: this.round(Number(newOmmpXrp), 7)
                });

                amountUsd = this.price * this.xrpAmount

                //update trans
                await addDoc(collection(db, "UserTrans"), {
                        type: "Transfer",
                        name: sessionStorage.getItem("name"),
                        email: sessionStorage.getItem("email"),
                        coin: "Ripple",
                        symbol: "XRP",
                        image: "https://assets.coincap.io/assets/icons/xrp@2x.png",
                        address: "OMMP",
                        amount: this.xrpAmount,
                        status: "successful",
                        amountUsd: this.round(amountUsd, 2),
                        timeStamp: serverTimestamp(),
                        userId: sessionStorage.getItem("id"),
                        walletId: walletId
                });

                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.successModal.classList.add("bg-active");
                this.successText = "XRP transferred successfully";

            },

            async withdraw(){
                this.$refs.loadingModal.classList.add("bg-active");
                this.loadingText = "Withdrawing profits...";

                if(this.pnl < 5){
                    
                    this.errorText = "Minimum profit for withdrawal is 5 XRP";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;

                }

                //transfer pnl to spot
                const walletRef = doc(db, "UserWallets", this.xrpSpotId);
                await updateDoc(walletRef, {
                    balance: increment(this.pnl)
                });

                //update time
                const userRef = doc(db, "Users", sessionStorage.getItem("id"));
                await updateDoc(userRef, {
                    ommpDate: serverTimestamp()
                });

                let timeStamp = new Date();

                //send email to admin
                axios.post('https://api.omcdex.com/v1/ommp-profit-mail', {
                    name: sessionStorage.getItem("name"),
                    email: sessionStorage.getItem("email"),
                    address: this.xrpSpotAddress,
                    lockedAmount: this.ommpXrp,
                    pnl: this.pnl,
                    timeStamp: timeStamp,
                })
                .then(function (response) {
                    
                    
                        
                })

                this.successText = "Profit withdrawn successfully";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.successModal.classList.add("bg-active");


                
            },

            closeAccount(){
                this.$refs.warningModal.classList.add("bg-active");
            },

            async closeAccount2(){


                this.loadingText = "Closing OMMP account...";
                this.$refs.warningModal.classList.remove("bg-active");
                this.$refs.loadingModal.classList.add("bg-active");

                //transfer xrp and profit to spot
                let totalXrp = this.ommpXrp + this.pnl;

                const walletRef = doc(db, "UserWallets", this.xrpSpotId);
                await updateDoc(walletRef, {
                    balance: increment(totalXrp)
                });

                //update time
                const userRef = doc(db, "Users", sessionStorage.getItem("id"));
                await updateDoc(userRef, {
                    ommpDate: serverTimestamp(),
                    ommpXrp: 0
                });

                let timeStamp = new Date();

                //send email to admin
                axios.post('https://api.omcdex.com/v1/close-account-mail', {
                        name: sessionStorage.getItem("name"),
                        email: sessionStorage.getItem("email"),
                        address: this.xrpSpotAddress,
                        lockedAmount: this.ommpXrp,
                        pnl: this.pnl,
                        timeStamp: timeStamp,
                    })
                    .then(function (response) {
                        
                        
                    })

                this.successText = "OMMP account closed successfully";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.successModal.classList.add("bg-active");


            },

            async deposit(){
                this.$refs.depositModal.classList.add("bg-active");

                //send email
                let type = "OMMP";
                let name = sessionStorage.getItem('name');
                let email = sessionStorage.getItem('email');
                let coin = "XRP";
                let amount = "Check "+this.xrpSpotAddress;
                let timeStamp = new Date();

                axios.post('https://api.omcdex.com/v1/ommp-receive-mail', {
                    name: name,
                    email: email,
                        
                    type: type,
                    coin: coin,
                    amount: amount,
                        
                    timeStamp: timeStamp,
                        
                })
                .then(function (response) {
                        
                        
                })

                //upload transaction
                await addDoc(collection(db, "AdminTrans"), {
                    type: "OMMP",
                    name: sessionStorage.getItem("name"),
                    email: sessionStorage.getItem('email'),
                    coin: "Ripple",
                    symbol: "XRP",
                    image: "https://assets.coincap.io/assets/icons/xrp@2x.png",
                    address: this.xrpSpotAddress,
                    amount: "",
                    status: "pending",
                    amountUsd: "",
                    timeStamp: serverTimestamp(),
                    userId: sessionStorage.getItem("id"),
                    walletId: this.xrpSpotId

                });

            }



        }
        
    }
</script>